var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"instagram"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M83,23a22,22,0,0,1,22,22V83a22,22,0,0,1-22,22H45A22,22,0,0,1,23,83V45A22,22,0,0,1,45,23Zm0-8H45A30.09,30.09,0,0,0,15,45V83a30.09,30.09,0,0,0,30,30H83a30.09,30.09,0,0,0,30-30V45A30.09,30.09,0,0,0,83,15Z","key":0}),React.createElement("path",{"d":"M90.14,32a5.73,5.73,0,1,0,5.73,5.73A5.74,5.74,0,0,0,90.14,32Z","key":1}),React.createElement("path",{"d":"M64.27,46.47A17.68,17.68,0,1,1,46.6,64.16,17.69,17.69,0,0,1,64.27,46.47m0-8A25.68,25.68,0,1,0,90,64.14,25.68,25.68,0,0,0,64.27,38.47Z","key":2})])]);
}

Instagram.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 128 128"};

module.exports = Instagram;

Instagram.default = Instagram;
